

export default {
    provinsiList: [],
    kabupatenKotaList: [],
    kecamatanList: [],
    totalProv: 0,
    totalKabKot: 0,
    totalKec: 0
}
